import mutations from "./mutations";
import getters from "./getters";

export const customerState = {
    customer: {
        mobileMenuShown: true,
        storedData: {
            orders: [],
            personalData: {},
            address: {},
        },
    }
};

export const customerMutations = {
    ...mutations
};

export const customerGetters = {
    ...getters
};
